import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {SimulationSessionProvider} from '../data/SimulationSessionProvider';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

  bigScreen = false;

  ngOnInit(): void {
  }

  constructor(private router: Router,
              private simulationSessionProvider: SimulationSessionProvider) {
  }

  startSimulation() {
    this.simulationSessionProvider.startSimulationSession();
    this.router.navigate(['/startSimulation']);
  }


}
